import { render, staticRenderFns } from "./highRiskCount.vue?vue&type=template&id=1d07720c&scoped=true"
import script from "./highRiskCount.vue?vue&type=script&lang=js"
export * from "./highRiskCount.vue?vue&type=script&lang=js"
import style0 from "./highRiskCount.vue?vue&type=style&index=0&id=1d07720c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d07720c",
  null
  
)

export default component.exports